(() => {
  const formWithTerms = node => {
    const form = node?.closest?.('form') || node?.form;
    return form && form.querySelector('[data-cart-terms]') ? form : null;
  };
  const parts = form => {
    const wrapper = form.querySelector('[data-cart-terms]');
    return {
      checkbox: wrapper.querySelector('[data-cart-terms-checkbox]'),
      error: wrapper.querySelector('[data-cart-terms-error]')
    };
  };
  const block = (event, form) => {
    const { checkbox, error } = parts(form);
    if (!checkbox || checkbox.checked) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (error) error.hidden = false;
    checkbox.setAttribute('aria-invalid', 'true');
    if (error) checkbox.setAttribute('aria-describedby', error.id);
    checkbox.focus();
  };

  // Ticking fills the hidden cart attributes that save the acceptance on the order.
  // The version follows the label the shopper can see.
  const record = wrapper => {
    const checkbox = wrapper.querySelector('[data-cart-terms-checkbox]');
    const accepted = wrapper.querySelector('[data-cart-terms-accepted]');
    const acceptedAt = wrapper.querySelector('[data-cart-terms-accepted-at]');
    const version = wrapper.querySelector('[data-cart-terms-version-input]');
    if (!checkbox || !accepted || !acceptedAt || !version) return;
    if (!checkbox.checked) {
      accepted.value = '';
      acceptedAt.value = '';
      version.value = '';
      return;
    }
    accepted.value = 'Yes';
    if (!acceptedAt.value) acceptedAt.value = new Date().toISOString();
    version.value = wrapper.dataset.cartTermsMode === 'preorder'
      ? wrapper.dataset.cartTermsPreorderVersion || ''
      : wrapper.dataset.cartTermsVersion || '';
  };

  // Quantity changes re-render the cart lines, so the pre-order notices follow the lines left in the cart.
  const setPreorderMode = hasPreorder => {
    const mode = hasPreorder ? 'preorder' : 'standard';
    document.querySelectorAll('[data-cart-preorder-banner]').forEach(banner => {
      banner.hidden = !hasPreorder;
    });
    document.querySelectorAll('[data-cart-terms]').forEach(wrapper => {
      if (wrapper.dataset.cartTermsMode === mode) return;
      wrapper.dataset.cartTermsMode = mode;
      wrapper.querySelectorAll('[data-cart-terms-label]').forEach(label => {
        label.hidden = label.dataset.cartTermsLabel !== mode;
      });
      // Accepting the standard terms does not cover pre-order terms, so ask again.
      const checkbox = wrapper.querySelector('[data-cart-terms-checkbox]');
      if (hasPreorder && checkbox) checkbox.checked = false;
      record(wrapper);
    });
  };
  let observer = null;
  const observeCartLines = () => {
    if (observer) observer.disconnect();
    const list = document.querySelector('[data-cart-item-list]');
    if (!list) return;
    observer = new MutationObserver(() => {
      setPreorderMode(!!list.querySelector('[data-cart-preorder-line]'));
    });
    observer.observe(list, { childList: true });
  };
  observeCartLines();
  document.addEventListener('shopify:section:load', observeCartLines);

  window.addEventListener('click', event => {
    const button = event.target.closest?.('[name="checkout"]');
    if (!button || button.disabled) return;
    const form = formWithTerms(button);
    if (form) block(event, form);
  }, true);
  window.addEventListener('submit', event => {
    const form = formWithTerms(event.target);
    if (!form) return;
    const submitter = event.submitter;
    if (submitter?.name === 'update') return;
    if (submitter ? submitter.name === 'checkout' : form.querySelector('[name="checkout"]')) block(event, form);
  }, true);
  document.addEventListener('change', event => {
    if (!event.target.matches?.('[data-cart-terms-checkbox]')) return;
    const wrapper = event.target.closest('[data-cart-terms]');
    if (wrapper) record(wrapper);
    if (!event.target.checked) return;
    event.target.removeAttribute('aria-invalid');
    event.target.removeAttribute('aria-describedby');
    const error = wrapper?.querySelector('[data-cart-terms-error]');
    if (error) error.hidden = true;
  });
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    document.querySelectorAll('[data-cart-terms]').forEach(wrapper => {
      const checkbox = wrapper.querySelector('[data-cart-terms-checkbox]');
      if (checkbox) checkbox.checked = false;
      record(wrapper);
    });
  });
})();
